import React, { createContext, useContext, useState } from 'react';

const LayoutContext = createContext();

export const useLayout = () => useContext(LayoutContext);

export const LayoutProvider = ({ children }) => {
  const [layoutConfig, setLayoutConfig] = useState({
    backgroundColor: '#00022D', // Cor padrão
    headerContent: null, // Conteúdo padrão do cabeçalho
    // Adicione outras configurações de layout conforme necessário
  });

  return (
    <LayoutContext.Provider value={{ layoutConfig, setLayoutConfig }}>
      {children}
    </LayoutContext.Provider>
  );
};
